import { DatePicker, Form } from "antd";
import { isAfter, startOfDay } from "date-fns";
import React, { ReactNode } from "react";
import { b2c2bDateFormat } from "../utils/antd.props";
import { NamePath } from "antd/es/form/interface";

// Can not select dates after today
const disabledFutureDates = (current) => {
  return current && isAfter(current, startOfDay(new Date()));
};

export default function DOBField(props: {label: ReactNode, name: NamePath, rules?: any[]}) {
  return (
    <Form.Item {...props}>
      <DatePicker format={b2c2bDateFormat} disabledDate={disabledFutureDates}/>
    </Form.Item>
  )
}

DOBField.defaultProps = {
  label: "Date of Birth",
  name: "date_of_birth"
}